import React, { FC, useState } from "react";
import { Badge, Button, Tooltip, Avatar, Tag } from "antd";
import { SyncOutlined, SortAscendingOutlined } from "@ant-design/icons";

interface HeaderRightProps {
  pendingSyncN: number;
  sync: () => void;
  presence: string[];
}

export const HeaderRight: FC<HeaderRightProps> = ({
  pendingSyncN,
  sync,
  presence,
}) => {
  const [online] = useState(true);

  return (
    <>
      {!online && (
        <Tag bordered={false} color="error">
          Offline
        </Tag>
      )}
      <Tooltip key="sort" title="Ordenar">
        <Badge>
          <Button type="link" icon={<SortAscendingOutlined />} />
        </Badge>
      </Tooltip>
      <Tooltip key="sync" title="Actualizar">
        <Badge count={pendingSyncN} dot>
          <Button type="link" icon={<SyncOutlined />} onClick={sync} />
        </Badge>
      </Tooltip>
      {presence.length > 0 ? (
        <Avatar.Group key="presence" maxCount={1}>
          {presence.map((user, i) => (
            <Tooltip key={i} title={user}>
              <Avatar>{user[0]}</Avatar>
            </Tooltip>
          ))}
        </Avatar.Group>
      ) : null}
    </>
  );
};
